
import { defineComponent } from "vue";
import MarkInputComponent from "@/components/MarkInputComponent.vue";
import { SubjectName } from "@/scripts/Types";
import { sum } from "@/scripts/helper";

export default defineComponent({
  name: "Qualifikation2",
  components: {
    MarkInputComponent,
  },
  props: ["subjectsMuendlich", "ownSubjects"],
  data() {
    return {
      singlePointsQuali2: [0, 0, 0, 0, 0],
    };
  },
  watch: {},
  methods: {
    getTotalQuali2() {
      let res;
      if (this.subjectsMuendlich.length == 1) {
        this.singlePointsQuali2[4] = 0;
      }
      if (this.subjectsMuendlich.length == 1) {
        res = sum(this.singlePointsQuali2.map((x) => x * 5));
      } else {
        res = sum(this.singlePointsQuali2.map((x) => x * 4));
      }
      this.$emit("pointsChange", res);
      return res;
    },
  },
});
